<template>
  <v-row>
    <v-col class="d-flex flex-column justify-center">
      <v-icon
        style="font-size: 150px"
        :color="
          status === 'success' ? 'green' : status === 'timeout' || status === 'error' ? 'orange darken-1' : 'green'
        "
      >
        {{
          status === "success"
            ? "mdi-check-circle"
            : status === "timeout"
            ? "mdi-clock-alert"
            : status === "error"
            ? "mdi-clock-alert"
            : "mdi-check-circle"
        }}
      </v-icon>

      <h1
        class="text-center my-3 font-weight-light"
        style="font-size: 40px"
        v-text="status"
      />

      <p
        class="capitalize text-center mt-5"
        v-html="transaction ? transaction.ResultDesc : status"
      ></p>
      <p class="capitalize text-center mt-5" v-html="message !== 'success' ? message: ''"></p>
      <v-btn
        v-if="status === 'success'"
        :href="payload.success_url"
        class="mt-5"
        color="green"
      >
        Finish
      </v-btn>

      <v-btn v-else @click="retry" class="mt-5" color="blue-grey lighten-4"
        >Retry</v-btn
      >
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "Success",
  props: {
    status: {
      type: String,
      default: "",
    },
    transaction: {
      type: Object,
      default: () => {},
    },
    payload: {
      type: Object,
      default: () => {},
    },
    message: {
      type: String,
      default: "",
    }
  },
  data: function () {
    return {};
  },
  methods: {
    retry: function () {
      this.$emit("retry");
    },
  },
};
</script>
